import React from "react";
import { Link } from "react-router-dom";
import { faClipboardList, faClock, faExclamationCircle, faFile, faFileAlt, faFileExcel, faFilePdf, faPlus, faRotateRight, faUpload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Header.scss';
import Searcher from './components/Searcher';

export default function Header({
    viewSearch,
    detalleTab,
    onNew,
    onSearch, 
    onExport, 
    onCompare,
    onReport,
    onAvisos,
    onNotify,
    onTickets,
    onNoGenerated,
    onRfClearence
}) {
    let pathname = window.location.pathname === '/' ? 'home' : window.location.pathname.replace('/', '');
    const user = JSON.parse(localStorage.getItem('user'));
    const handleNew = () => onNew();
    const handleChange = (search, searchData) => onSearch(search, searchData);
    const handleExport = (item = null) => onExport(item);
    const handleCompare = () => onCompare();
    const handleReport = () => onReport();
    const handleAvisos = () => onAvisos();
    const handleNotify = () => onNotify();
    const pageName = pathname.includes("/") ? pathname.split("/")[0] : pathname;
    const itemPageName = pageName === 'proveedores' ? 'proveedor' : pageName === 'comerciales' ? 'taller' : pageName.substring(0, pageName.length - 1);
    const ticketCount = 0;

    return (
        <div className="w-100 d-flex flex-column align-items-start">
            <div className="w-100 d-flex align-items-center justify-content-between">
                <h1 className="page-name">{pageName?.replace('-', ' ')}</h1>

                <div className="flex-grow-1 d-flex align-items-center justify-content-end mb-2">
                { pageName !== 'settings' &&
                    <div className="d-flex align-items-center align-self-end">
                        { pageName === 'incidencias' &&
                            <div className="w-100 d-flex align-items-center">
                                { (user.rol_id === 1 || user.rol_id === 5) &&
                                    <button className="btn btn-add" onClick={() => handleExport('perdidas')}>
                                        <span className="add">
                                            <FontAwesomeIcon icon={faFileExcel} size="1x" className="action" color="#215732" /> 
                                        </span>
                                        Pérdidas
                                    </button>
                                }

                                <button className="btn btn-add mx-3"  onClick={() => handleExport('culpa')}>
                                    <span className="add">
                                        <FontAwesomeIcon icon={faFileExcel} size="1x" className="action" color="#215732" /> 
                                    </span>
                                    Culpa Recomotor 
                                </button>

                                <button className="btn btn-add"  onClick={() => handleAvisos()}>
                                    <span className="add">
                                        <FontAwesomeIcon icon={faExclamationCircle} size="1x" className="action" color="#215732" /> 
                                    </span>
                                    Avisos 
                                </button>
                            </div>
                        }
                        { pageName === 'facturas' &&
                            <>
                                <button className="btn btn-add me-3"  onClick={() => onNoGenerated()}>
                                    <span className="add">
                                        <FontAwesomeIcon icon={faRotateRight} size="1x" className="action" color="#215732" /> 
                                    </span>
                                    No generadas
                                </button>

                                <button className="btn btn-add me-3"  onClick={() => handleCompare()}>
                                    <span className="add">
                                        <FontAwesomeIcon icon={faFileExcel} size="1x" className="action" color="#215732" /> 
                                    </span>
                                    Comparar
                                </button>

                                <button className="btn btn-add me-3"  onClick={() => handleExport()}>
                                    <span className="add">
                                        <FontAwesomeIcon icon={faFileExcel} size="1x" className="action" color="#215732" /> 
                                    </span>
                                    Exportar
                                </button>

                                <button className="btn btn-add"  onClick={() => handleReport()}>
                                    <span className="add">
                                        <FontAwesomeIcon icon={faFileAlt} size="1x" className="action" color="#215732" /> 
                                    </span>
                                    Informe
                                </button>
                            </>
                        }
                        { (pageName === 'clientes' && (user.rol_id === 1 || user.rol_id === 4)) &&
                            <button className="btn btn-add me-3"  onClick={() => handleExport('extraccion')}>
                                <span className="add">
                                    <FontAwesomeIcon icon={faFileExcel} size="1x" className="action" color="#215732" /> 
                                </span>
                                Extracción
                            </button>
                        }
                        { (pageName === 'clientes' && user.rol_id === 1) &&
                            <>
                                <button className="btn btn-add me-3"  onClick={() => handleExport('ventas')}>
                                    <span className="add">
                                        <FontAwesomeIcon icon={faFileExcel} size="1x" className="action" color="#215732" /> 
                                    </span>
                                    Ventas
                                </button>

                                <button className="btn btn-add me-3"  onClick={() => handleExport('margen')}>
                                    <span className="add">
                                        <FontAwesomeIcon icon={faFileExcel} size="1x" className="action" color="#215732" /> 
                                    </span>
                                    Ventas con margen
                                </button>
                            </>
                        }
                        { (pageName === 'proveedores' && (user.rol_id === 1 || user.rol_id === 6)) &&
                            <button className="btn btn-add me-3"  onClick={() => handleExport()}>
                                <span className="add">
                                    <FontAwesomeIcon icon={faFileAlt} size="1x" className="action" color="#215732" /> 
                                </span>
                                Consumo
                            </button>
                        }
                        { (pageName === 'comerciales') &&
                            <button className="btn btn-add me-3"  onClick={() => handleExport()}>
                                <span className="add">
                                    <FontAwesomeIcon icon={faFileAlt} size="1x" className="action" color="#215732" /> 
                                </span>
                                Conversión clientes
                            </button>
                        }

                        { (pageName === 'envios') &&
                            <>
                                <button className="btn btn-add me-3"  onClick={onRfClearence}>
                                    <span className="add">
                                        <FontAwesomeIcon icon={faUpload} size="1x" className="action" color="#215732" /> 
                                    </span>
                                    RF Clearence
                                </button>
                                <button className="btn btn-add me-3"  onClick={() => handleExport('fin-dia')}>
                                    <span className="add">
                                        <FontAwesomeIcon icon={faFilePdf} size="1x" className="action" color="#215732" /> 
                                    </span>
                                    Fin de día
                                </button>
                            </>
                        }
                        
                        { (pageName === 'envios' && user.rol_id === 1) &&
                            <button className="btn btn-add me-3"  onClick={() => handleExport('consumo')}>
                                <span className="add">
                                    <FontAwesomeIcon icon={faFileAlt} size="1x" className="action" color="#215732" /> 
                                </span>
                                Consumo
                            </button>
                        }
                        
                        { (pageName === 'presupuestos') &&
                            <button className="btn btn-add me-3" onClick={() => onTickets()}>
                                <span className="add position-relative">
                                    <FontAwesomeIcon icon={faClipboardList} size="1x" className="action" color="#215732" />
                                    {ticketCount > 0 && (
                                        <span className="ticket-badge">{ticketCount}</span>
                                    )}
                                </span>
                                Tickets
                            </button>
                        }

                        { (pageName === 'presupuestos' && (user.rol_id === 1 || (user.rol_id === 2 && user.responsable))) ?
                            (<button className="btn btn-add me-3"  onClick={() => handleNotify()}>
                                <span className="add">
                                    <FontAwesomeIcon icon={faClock} size="1x" className="action" color="#215732" /> 
                                </span>
                                Pendientes Ecommerce
                            </button>) : null
                        }

                        { (pageName === 'presupuestos' && user.rol_id === 1) ?
                            (<button className="btn btn-add"  onClick={() => handleExport()}>
                                <span className="add">
                                    <FontAwesomeIcon icon={faFileAlt} size="1x" className="action" color="#215732" /> 
                                </span>
                                Presupuestos Clientes
                            </button>) : null
                        }

                        { ( pageName !== 'ventas' && 
                            pageName !== 'facturas' && 
                            pageName !== 'facturas-desguaces' && 
                            pageName !== 'notas-cargo' &&
                            pageName !== 'devoluciones-mercancias' && 
                            pageName !== 'incidencias' && 
                            pageName !== 'envios' &&
                            pageName !== 'finanzas' &&
                            pageName !== 'comerciales' &&
                            pageName !== 'clientes' &&
                            pageName !== 'proveedores' &&
                            pageName !== 'vehiculos' &&
                            pageName !== 'users')
                            &&  
                                <Link to={"/" + itemPageName + "/0"} className="ms-3">
                                    <button className="btn btn-add">
                                        <span className="add">
                                            <FontAwesomeIcon icon={faPlus} size="1x" className="action" color="#215732" />
                                        </span>
                                        Nuevo
                                    </button>

                                </Link>
                        }

                        { ( pageName === 'envios' || 
                            pageName === 'comerciales' || 
                            pageName === 'proveedores' || 
                            pageName === 'devoluciones-mercancias' ||
                            pageName === 'facturas-desguaces' ||
                            pageName === 'clientes' ||
                            pageName === 'users') 
                            &&
                            <button className="btn btn-add" onClick={handleNew}>
                                <span className="add">
                                    <FontAwesomeIcon icon={faPlus} size="1x" className="action" color="#215732" />
                                </span>
                                 Nuevo
                            </button>                              
                        }
                        { (pageName === 'presupuestos') &&
                            <button className="btn btn-add ms-3" onClick={handleNew}>
                                <span className="add">
                                    <FontAwesomeIcon icon={faFile} size="1x" className="action" color="#215732" />
                                </span>
                                 Nuevo
                            </button>   
                        }
                    </div>
                }
                </div>
            </div>
            
            { (viewSearch) &&
                <Searcher 
                    detalleTab={detalleTab}
                    pageName={pageName}
                    onChange={handleChange}/>
            }
        </div>
    );
}